import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setProjectSortBy } from "src/redux";
import { searchObjectsByName } from "src/app/components/DictionarySortDropdown/DictionarySortDropdown";
import { ProjectColumn } from "src/redux/project/projectReducer";
import { RootState } from "src/redux/reducers";
import SortDropdown from "src/app/components/SortDropdown/SortDropdown";
import SortFieldsButton from "src/app/dropdowns/SortFieldsDropdown/SortFieldsButton";

import "./SortProjectsDropdown.scss";

interface SortProjectsDropdownProps {
  fields: ProjectColumn[];
}

function SortProjectsDropdown({ fields = [] }: SortProjectsDropdownProps) {
  const [value, setValue] = useState("");

  const dispatch = useDispatch();

  const {
    projectFiltersReducer: { sortBy, hiddenColumns },
  } = useSelector((state: RootState) => state);

  const filteredFields = fields.filter((c) => !hiddenColumns.includes(c.uuid));

  const options = value
    ? searchObjectsByName(value, filteredFields)
    : filteredFields;

  const foundActiveSortingColumn = options.find(
    (option: ProjectColumn) => option.uuid === sortBy,
  );

  return (
    <SortDropdown
      options={options}
      handleClick={(newSortBy) => dispatch(setProjectSortBy(newSortBy))}
      dropdownMenuClassName="sort-projects-dropdown__menu"
      sortBy={sortBy}
      inputValue={value}
      onInputChange={(e) => setValue(e.target.value)}
      dropdownPlacement="bottom-end"
    >
      <SortFieldsButton
        activeSortingColumnName={foundActiveSortingColumn?.name}
      />
    </SortDropdown>
  );
}

export default SortProjectsDropdown;
